import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, vModelSelect as _vModelSelect, withDirectives as _withDirectives, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "p-4 bg-trader-gray flex flex-col overflow-hidden" }
const _hoisted_2 = { class: "space-y-4 flex flex-col overflow-auto max-h-[1000px]" }
const _hoisted_3 = {
  key: 0,
  class: "bg-trader-light-gray rounded-md shadow-md p-4"
}
const _hoisted_4 = { class: "flex items-center space-x-2 mb-4" }
const _hoisted_5 = { class: "text-lg font-bold text-trader-dark-yellow" }
const _hoisted_6 = { class: "min-w-full divide-y divide-gray-200" }
const _hoisted_7 = { class: "bg-trader-yellow" }
const _hoisted_8 = { class: "bg-trader-light-gray divide-y divide-trader-gray" }
const _hoisted_9 = { key: 0 }
const _hoisted_10 = ["onUpdate:modelValue", "onChange"]
const _hoisted_11 = ["value"]
const _hoisted_12 = ["value"]
const _hoisted_13 = { key: 1 }
const _hoisted_14 = {
  key: 1,
  class: "flex items-center space-x-2"
}
const _hoisted_15 = { key: 0 }
const _hoisted_16 = ["data-ui", "onClick"]
const _hoisted_17 = { key: 0 }
const _hoisted_18 = { key: 1 }

import {mutation, query} from "@/graphql";
import SignalBus from "@/application/SignalBus";
import {onMounted, reactive, ref} from 'vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'ShowReport',
  props: {
  errors: {
    type: Array,
    default: () => []
  },
  messages: Array,
},
  setup(__props) {

const props = __props;


const buttonStates = reactive<Record<string, { loading: boolean; success: boolean }>>({});
const selectStates = reactive<Record<string, { loading: boolean; success: boolean }>>({});

const purchasers = ref([]);

function getValue(error: any, key: string): string {
  const found = error.data?.find((item: any) => item.key === key);
  return found ? found.value : '';
}


function filteredErrors(code: string) {
  let errors = props.errors.filter((error: any) => error.code === code);

  //));

  if (code === "PRODUCT_NUMBER_NOT_FOUND") {
    errors = errors.map((error: any) => {
      error.purchaser = error.purchaser || purchasers.value?.[0]?.id;
      return error;
    });
  }

  return errors;
}

const errorTypes = [
  {
    code: 'PRODUCT_NUMBER_NOT_FOUND',
    title: 'Folgende Artikel existieren nicht',
    details: [
      {key: 'PRODUCT_NUMBER', label: 'Artikelnummer'},
      {
        key: 'purchaser',
        label: 'Einkaufsbereich',
        type: 'select',
        actionType: 'selectPurchaser'
        // Es werden hier keine Options definiert, da diese dynamisch
        // aus "shoppingAreas" generiert werden.
      },
      {
        key: 'ACTION',
        label: 'Aktion ausführen',
        type: 'button',
        buttonText: 'Ausführen',
        actionType: 'createArticle'
      }
    ]
  },
  {
    code: 'PRODUCT_IS_ON_MAGAZINE',
    title: 'Folgende Artikel befindet sich schon im Magazin',
    details: [
      {key: 'PRODUCT_NUMBER', label: 'Artikelnummer'},
      {key: 'PAGE_POSITION', label: 'Seite'},
      {key: 'MARKET_NUMBER', label: 'Markt'}
    ]
  },
  {
    code: 'PRODUCT_HAS_WRONG_PURCHASER',
    title: 'Folgende Artikel hatten einen anderen Einkaufsbereich',
    details: [
      {key: 'PRODUCT_NUMBER', label: 'Artikelnummer'},
      {key: 'PURCHASER_ID', label: 'Einkaufsbereich'},
    ]
  },
  {
    code: 'PRODUCT_NO_MATCHING_PLACEHOLDER',
    title: 'Folgende Artikel hatten keinen passenden Platzhalter',
    details: [
      {key: 'PRODUCT_NUMBER', label: 'Artikelnummer'},
      {
        key: 'MARKET_NUMBERS',
        label: 'Märkte',

      }
    ]
  },
  {
    code: 'PRODUCT_IS_IN_CLIPBOARD',
    title: 'Folgende Artikel befindet sich schon in der Zwischenablage',
    details: [
      {key: 'PRODUCT_NUMBER', label: 'Artikelnummer'},
      {
        key: 'ACTION',
        label: 'Aus der Zwischenablage platzieren',
        type: 'button',
        buttonText: 'Zwischenablage',
        actionType: 'clipboard'
      },
      {
        key: 'ACTION',
        label: 'Aus dem Stammartikel platzieren',
        type: 'button',
        buttonText: 'Stammartikel',
        actionType: 'baseArticle'
      }
    ]
  },
  {
    code: 'MORE_PLACEHOLDERS_THAN_PRODUCTS',
    title: 'Nicht genügend Artikel um alle Platzhalter zu füllen',
    details: [
      {key: 'PLACEHOLDER_NUMBERS', label: 'Platzhalter'}
    ]

  },
  {
    code: 'MORE_PRODUCTS_THAN_PLACEHOLDERS',
    title: 'Kein Platz mehr um diese Artikel zu platzieren',
    details: [
      {
        key: 'PRODUCT_NUMBERS',
        label: 'Artikelnummer',
        transform: (value: string) => JSON.parse(value).join(' ')
      }
    ]
  },
  {
    code: 'PRODUCT_NOT_ON_MAGAZINE',
    title: 'Folgende Artikel konnten nicht im Quellmagazin gefunden werden',
    details: [
      {key: 'PRODUCT_NUMBER', label: 'Artikelnummer'}
    ]
  },

];

function reloadPage() {
  location.reload();
}
function getSelectedLabel(key) {
  // find in purchasers the purchaser with error[detail.key] and give back the name and icon
 return  purchasers.value.find(purchaser => purchaser.id === key)?.teamIcon + " - " + purchasers.value.find(purchaser => purchaser.id === key)?.name;
}
async function handleAction(error: any, actionType: string, key: string) {
  // Setze den Lade-Status für diesen Button
  buttonStates[key] = {loading: true, success: false};
  selectStates[key] = { loading: true, success: false };
  try {
    if (actionType === "createArticle") {
      await placeNewProduktOnPage(error);
    } else if (actionType === "clipboard") {
      await placeProductOutOfClipboard(error, 1);
    } else if (actionType === "baseArticle") {
      await placeProductOutOfClipboard(error, 2);
    }
    // Bei Erfolg: grüner Haken anzeigen
    buttonStates[key].success = true;
    selectStates[key].success = true;
  } catch (e) {
    console.error(e);
  } finally {
    // Lade-Status beenden
    buttonStates[key].loading = false;
    selectStates[key].loading = false;
    SignalBus.emit("reload-page");
  }
}
async function placeNewProduktOnPage(error: any) {
  const value = {
    productNumber: getValue(error, 'PRODUCT_NUMBER'),
    virtualId: getValue(error, 'VIRTUAL_ID'),
    pageId: getValue(error, 'PAGE_ID'),
    purchaserId: error.purchaser
  };

  const [data, err] = await mutation.placeNewProduktOnPage(value.pageId, value.productNumber, value.purchaserId, value.virtualId);
  if (err) {
    console.error(err);
    return;
  }
}

async function placeProductOutOfClipboard(error: any, rule: 0, index) {
  const value = {
    productNumber: getValue(error, 'PRODUCT_NUMBER'),
    virtualId: getValue(error, 'VIRTUAL_ID'),
    pageId: getValue(error, 'PAGE_ID'),
    purchaserId: error.purchaser
  };

  try {
    const [data, err] = await query.placeProductByRule(value.pageId, value.productNumber, value.virtualId, rule);
    if (err) {
      console.error(err);
      return;
    }
  } catch (e) {
    console.error(e);
  } finally {

  }
}


async function getPurchaserForCurrentUser() {
  const [data, err] = await query.getPurchaserForCurrentUser();
  if (err) {
    console.error(err);
    return;
  }
  //
  purchasers.value = data
}


onMounted(() => {
  getPurchaserForCurrentUser();
});


function handleSelectChange(event: Event, error: any, detail: any) {
  const target = event.target as HTMLSelectElement;
  // Da die Options aus dem shoppingAreas-Array stammen, entspricht der
  // ausgewählte Wert der ID des entsprechenden Einkaufsbereichs.
  const selectedAreaId = target.value;
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(), _createElementBlock(_Fragment, null, _renderList(errorTypes, (errorType) => {
        return (_openBlock(), _createElementBlock(_Fragment, {
          key: errorType.code
        }, [
          (filteredErrors(errorType.code).length)
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                _createElementVNode("div", _hoisted_4, [
                  (_openBlock(), _createElementBlock("svg", {
                    class: _normalizeClass(["w-6 h-6", errorType.code === 'PRODUCT_NUMBER_NOT_FOUND' ? 'text-trader-dark-red' : 'text-trader-dark-yellow']),
                    fill: "none",
                    stroke: "currentColor",
                    viewBox: "0 0 24 24"
                  }, _cache[0] || (_cache[0] = [
                    _createElementVNode("path", {
                      "stroke-linecap": "round",
                      "stroke-linejoin": "round",
                      "stroke-width": "2",
                      d: 'M13 16h-1v-4h-1m1-4h.01M12 20h.01M19 12a7 7 0 11-14 0 7 7 0 0114 0z'
                    }, null, -1)
                  ]), 2)),
                  _createElementVNode("h1", _hoisted_5, _toDisplayString(errorType.title), 1)
                ]),
                _createElementVNode("table", _hoisted_6, [
                  _createElementVNode("thead", _hoisted_7, [
                    _createElementVNode("tr", null, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(errorType.details, (detail) => {
                        return (_openBlock(), _createElementBlock("th", {
                          key: detail.key,
                          class: "px-6 py-3 text-left text-xs font-medium text-trader-dark-yellow uppercase tracking-wider"
                        }, _toDisplayString(detail.label), 1))
                      }), 128))
                    ])
                  ]),
                  _createElementVNode("tbody", _hoisted_8, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filteredErrors(errorType.code), (error, idx) => {
                      return (_openBlock(), _createElementBlock("tr", {
                        key: errorType.code + '-' + idx
                      }, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(errorType.details, (detail) => {
                          return (_openBlock(), _createElementBlock("td", {
                            key: detail.key,
                            class: "px-6 whitespace-nowrap text-trader-dark-yellow"
                          }, [
                            (detail.type === 'select')
                              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                  (!buttonStates[`${errorType.code}-${idx}-createArticle`]?.success)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                                        _withDirectives(_createElementVNode("select", {
                                          "onUpdate:modelValue": ($event: any) => ((error[detail.key]) = $event),
                                          onChange: ($event: any) => (handleSelectChange($event, error, detail, idx, errorType.code)),
                                          class: "form-select"
                                        }, [
                                          (detail.key === 'purchaser')
                                            ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(purchasers.value, (purchaser, purchaserIdx) => {
                                                return (_openBlock(), _createElementBlock("option", {
                                                  key: purchaser.id,
                                                  value: purchaser.id
                                                }, _toDisplayString(purchaser.teamIcon) + " - " + _toDisplayString(purchaser.name), 9, _hoisted_11))
                                              }), 128))
                                            : (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(detail.options, (option) => {
                                                return (_openBlock(), _createElementBlock("option", {
                                                  key: option.value,
                                                  value: option.value
                                                }, _toDisplayString(option.label), 9, _hoisted_12))
                                              }), 128))
                                        ], 40, _hoisted_10), [
                                          [_vModelSelect, error[detail.key]]
                                        ])
                                      ]))
                                    : (_openBlock(), _createElementBlock("span", _hoisted_13, _toDisplayString(getSelectedLabel(error[detail.key])), 1))
                                ], 64))
                              : (detail.type === 'button')
                                ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                                    (!buttonStates[errorType.code + '-' + idx + '-' + detail.actionType]?.success)
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                                          _createElementVNode("button", {
                                            "data-ui": detail.label + idx,
                                            onClick: ($event: any) => (handleAction(error, detail.actionType, errorType.code + '-' + idx + '-' + detail.actionType)),
                                            class: "px-4 py-2 text-black rounded-md shadow-md bg-trader-dark-blue hover:bg-trader-blue"
                                          }, [
                                            ((!buttonStates[errorType.code + '-' + idx + '-' + detail.actionType]?.loading))
                                              ? (_openBlock(), _createElementBlock("span", _hoisted_17, _toDisplayString(detail.buttonText || 'Aktion ausführen'), 1))
                                              : _createCommentVNode("", true)
                                          ], 8, _hoisted_16)
                                        ]))
                                      : _createCommentVNode("", true),
                                    (buttonStates[errorType.code + '-' + idx + '-' + detail.actionType]?.success)
                                      ? (_openBlock(), _createElementBlock("span", _hoisted_18, _cache[1] || (_cache[1] = [
                                          _createElementVNode("svg", {
                                            xmlns: "http://www.w3.org/2000/svg",
                                            class: "w-6 h-6 text-green-500",
                                            fill: "none",
                                            viewBox: "0 0 24 24",
                                            stroke: "currentColor"
                                          }, [
                                            _createElementVNode("path", {
                                              "stroke-linecap": "round",
                                              "stroke-linejoin": "round",
                                              "stroke-width": "2",
                                              d: "M5 13l4 4L19 7"
                                            })
                                          ], -1)
                                        ])))
                                      : _createCommentVNode("", true)
                                  ]))
                                : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                                    _createTextVNode(_toDisplayString(detail.transform ? detail.transform(getValue(error, detail.key)) : getValue(error, detail.key)), 1)
                                  ], 64))
                          ]))
                        }), 128))
                      ]))
                    }), 128))
                  ])
                ])
              ]))
            : _createCommentVNode("", true)
        ], 64))
      }), 64))
    ]),
    _createElementVNode("div", { class: "flex justify-center mt-4" }, [
      _createElementVNode("button", {
        "data-ui": "reload-page",
        onClick: reloadPage,
        class: "px-4 py-2 text-black bg-trader-dark-blue rounded-md shadow-md hover:bg-trader-blue"
      }, " OK ")
    ])
  ]))
}
}

})